import { IconPrinter, IconShare } from "@tabler/icons";
import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import ArrowChevronLeftIcon from "../../assets/icons/ArrowChevronLeftIcon";
import SuccessModal from "../../components/common/modal/SuccessModal";
import ContentHeader from "../../components/ContentHeader/ContentHeader";
import Spinner from "../../components/Spinner/Spinner";
import { getPrintRequest, sendPrintRequest } from "../../service/api/RequestService";
import { getUserRequestsById } from "../../service/api/UserRequestsService";
import { transformUniversalDateToLocalDate } from "../../utils/dateUtils";
import { debtorGradeStatusToText } from "../../utils/gradeUtils";
import InfoImage from "../../assets/backgrounds/tabla-grades.svg";
import RequestGradeCartButton from "../../components/RequestGradeCartButton/RequestGradeCartButton";

import "./QueryDetail.scss";

const gradeInfo = [
    { name: "Excepcional", number: "01", description: "Riesgo extremadamente bajo" },
    { name: "Muy sólido", number: "02", description: "Riesgo muy bajo" },
    { name: "Sólido", number: "03", description: "Riesgo bajo" },
    { name: "Bueno", number: "04", description: "Riesgo inferior a la media" },
    { name: "Medio", number: "05", description: "Riesgo medio" },
    { name: "Precaución", number: "06", description: "Riesgo superior a la media" },
    { name: "Débil", number: "07", description: "Riesgo confirmado" },
    { name: "Muy débil", number: "08", description: "Riesgo elevado" },
    { name: "En dificultades", number: "09", description: "Riesgo muy elevado" },
    { name: "Fallido", number: "10", description: "Pérdida" }

]

export const QueryDetail = () => {

    const [requestDetail, setRequestDetail] = useState({});
    const [printing, setPrinting] = useState(false);
    const [sending, setSending] = useState(false);
    const [sendingSuccess, setSendingSuccess] = useState(false);
    const [loadingIdentifier, setLoadingIdentifier] = useState(false);
    const params = useParams();
    const history = useHistory();

    useEffect(() => {
        getUserRequestsById(params.requestId).then(data => setRequestDetail(data));
    }, [params.requestId]);

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, []);

    const getPdf = () => {
        setPrinting(true);
        getPrintRequest(requestDetail.id).then(data => {
            var file = new Blob([data], { type: 'application/pdf' });
            const fileURL = window.URL.createObjectURL(file);
            let alink = document.createElement('a');
            alink.href = fileURL;
            alink.download = `info-${requestDetail.debtor.identification}.pdf`;
            alink.click();
            setPrinting(false);
        })
    }

    const sendPdf = () => {
        setSending(true)
        sendPrintRequest(requestDetail.id).then(() => {
            setSending(false);
            setSendingSuccess(true)
        })
    }


    return (
        <div className="query-detail">
            <ContentHeader titulo="Resultado de eGrade" />
            {requestDetail && requestDetail.id ?
                (
                    <div className="container mt-xl-5 pt-2">
                        <div className="row justify-content-between pt-xl-4">
                            <div className="col-xs-3 col-md-2 col-xl-1 mt-4 ms-3 text-start">
                                <div className="link-back">
                                    <span onClick={() => history.goBack()}>
                                        <ArrowChevronLeftIcon width="20" fill="#5c157d" /> Volver
                                    </span>
                                </div>
                            </div>
                            <div className="col-12 col-md-3 col-xl-2 mt-4 text-end request-actions">
                                <div>
                                    <span className="icon-share" onClick={() => sendPdf()}>
                                        {sending ? <Spinner /> : <IconShare />}
                                    </span>
                                    <span className="icon-print" onClick={() => getPdf()}>
                                        {printing ? <Spinner /> : <IconPrinter />}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="row bg-white mx-1 shadow mt-3 ps-3 py-4 result-container">

                            <div className="col-12 col-sm-12 col-md-12 col-lg-6 identification-container">
                                <table className="table text-start table-identification">
                                    <tbody>
                                        <h3>Identificación</h3>
                                        <tr>
                                            <th>Identificador</th>
                                            <td data-label="Identificador">{requestDetail.debtor.identification}</td>
                                        </tr>
                                        <tr>
                                            <th>Denominación</th>
                                            <td data-label="Denominación">{requestDetail.debtor.name}</td>
                                        </tr>
                                        <tr>
                                            <th>Sede Social</th>
                                            <td data-label="Sede Social">{requestDetail.debtor.address}</td>
                                        </tr>
                                        <tr>
                                            <th>Actividad CNAE</th>
                                            <td data-label="Actividad CNAE">{requestDetail.debtor.cnae}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="col-12 col-sm-12 col-md-12 col-lg-5 px-6 data-container">

                                <table className="table-data col-xl-12">
                                    <thead className="text-start">
                                        <h3>Datos de la empresa</h3>
                                    </thead>
                                    <tbody className="text-start bg-light table-data-detail">
                                        <tr>
                                            <td className="table-data-child ps-2 px-xl-4 py-xl-3">
                                                <div className="userGradeData">
                                                    <h6>EMAIL</h6>
                                                    <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-mail" width="24" height="24" viewBox="0 0 24 24" strokeWidth="1" stroke="#93969b" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                        <rect x="3" y="5" width="18" height="14" rx="2" />
                                                        <polyline points="3 7 12 13 21 7" />
                                                    </svg><span className="date-text"> {requestDetail.debtor.email}</span>

                                                </div>

                                                <div className="userGradeData">
                                                    <h6>SITIO WEB</h6>
                                                    <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-world" width="24" height="24" viewBox="0 0 24 24" strokeWidth="1" stroke="#93969b" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                        <circle cx="12" cy="12" r="9" />
                                                        <line x1="3.6" y1="9" x2="20.4" y2="9" />
                                                        <line x1="3.6" y1="15" x2="20.4" y2="15" />
                                                        <path d="M11.5 3a17 17 0 0 0 0 18" />
                                                        <path d="M12.5 3a17 17 0 0 1 0 18" />
                                                    </svg> <span className="date-text">{requestDetail.debtor.site}</span>
                                                </div>
                                                <div className="userGradeData">
                                                    <h6>TELÉFONO</h6>
                                                    <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-phone" width="24" height="24" viewBox="0 0 24 24" strokeWidth="1" stroke="#93969b" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                        <path d="M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2" />
                                                    </svg>
                                                    <span className="date-text">{requestDetail.debtor.telephone}</span>
                                                </div>
                                                <div className="userGradeData">
                                                    <h6>FECHA DE CREACIÓN</h6>
                                                    <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-calendar" width="24" height="24" viewBox="0 0 24 24" strokeWidth="1" stroke="#93969b" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                        <rect x="4" y="5" width="16" height="16" rx="2" />
                                                        <line x1="16" y1="3" x2="16" y2="7" />
                                                        <line x1="8" y1="3" x2="8" y2="7" />
                                                        <line x1="4" y1="11" x2="20" y2="11" />
                                                        <line x1="11" y1="15" x2="12" y2="15" />
                                                        <line x1="12" y1="15" x2="12" y2="18" />
                                                    </svg>
                                                    <span className="date-text"> {transformUniversalDateToLocalDate(requestDetail.debtor.creationDate)}</span>

                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                        </div>
                        <div className="row container-grade-detail shadow mx-1 ps-xl-4 pe-xl-5 py-4 my-5">
                            <div className="col-12 col-sm-12 col-md-7 col-lg-7 col-xl-4 dates my-auto py-3">
                                <div className="date">
                                    Fecha solicitud: {transformUniversalDateToLocalDate(requestDetail.gradeRequestDate)}
                                </div>
                                <div className={`status ${requestDetail.status}`}>
                                    Estado: {debtorGradeStatusToText(requestDetail.status)}
                                </div>
                                <div className="date">
                                    Fecha expiración: {transformUniversalDateToLocalDate(requestDetail.gradeExpirationDate)}
                                </div>
                                <div className="col-12">
                                    {requestDetail.status === 'expired' ? (
                                        <div className="re-request-container">
                                            <span className="re-request">
                                                <RequestGradeCartButton company={requestDetail} loadingIdentifier={loadingIdentifier} setLoadingIdentifier={setLoadingIdentifier} />
                                            </span>
                                        </div>
                                    ) : null}

                                </div>

                                
                            </div>
                            <div className="d-flex justify-content-center col-12 col-sm-12 col-md-5 col-lg-5 col-xl-2 grade-big-number">
                                <div className={`grade grade-${requestDetail.debtor.grade}`}>
                                    {requestDetail.debtor.grade}
                                </div>
                            </div>
                            <div className="col-11 grade-level-image mt-4 mx-auto">
                                <img alt="info-grade-level" src={InfoImage} />
                            </div>
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 my-auto grade-level-board">
                                {gradeInfo.map((grade) => {
                                    return (
                                        <div className="row mt-2">
                                            <div className="col-4">
                                                <div className={`grade-info grade-${grade.number}`}>
                                                    {grade.name}
                                                </div>
                                            </div>
                                            <div className="col-1">
                                                <div className={`grade-number grade-${grade.number}`}>
                                                    {grade.number}
                                                </div>
                                            </div>
                                            <div className="col-7">
                                                <div className={`grade-description grade-${grade.number}`}>
                                                    {grade.description}
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                        {sendingSuccess
                            ?
                            <SuccessModal onClose={() => { setSendingSuccess(false) }} title="Información enviada con éxito"
                                description="La información sobre la petición se ha
                             enviado al correo electrónico asociado a tu usario. Por favor revisa tu bandeja de entrada." />
                            :
                            null}
                    </div>
                )
                : null}
        </div>
    )
}
